<template>
  <div>
    <el-select
      :value="value"
      size="small"
      filterable
      remote
      @change="handleChange"
      @blur="handleBlur"
      :remote-method="requestData"
      :loading="loading"
      placeholder="搜索并选择"
      style="width: 100%"
      ref="itemSelect"
    >
      <!-- <el-option
        disabled
        :key="0"
        label="请选择"
        :value="0"
        style="display: none"
      ></el-option> -->
      <el-option
        v-for="item in lists"
        :key="item.id"
        :label="`${item.code}（${item.name}-${item.specification}-${item.model_number}）`"
        :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { itemList } from '@/service/getData'

export default {
  props: {
    value: '',
    category: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData('', true)
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    handleBlur() {
      setTimeout(() => {
        this.$emit('blur', this.value)
      }, 100)
    },
    async requestData(query, all = false) {
      if (query !== '' || all) {
        this.loading = true
        let data = {
          query: query,
          commodity_category: this.category,
          size: 50,
        }
        let res = await itemList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
  },
}
</script>